(function () {
  // Resolve the collection handle from a same-origin URL path, or null if it isn't a collection URL.
  function collectionHandle(pathname) {
    var match = pathname.match(/^\/collections\/([^\/]+)/);
    return match ? match[1] : null;
  }

  // Decide which collection drives the wedding context.
  //
  // Prefer the CURRENT page when it is a collection: this commits the flag while the shopper is
  // still browsing the collection grid, so the next product page renders the correct media on the
  // FIRST paint (no reload). Only fall back to the referring page when the current page is not a
  // collection (e.g. a product page reached via a bare /products/ URL, or home/cart/blog).
  var handle = collectionHandle(window.location.pathname);

  if (handle === null) {
    var ref = document.referrer || '';
    if (!ref) return;

    var refUrl;
    try {
      refUrl = new URL(ref);
    } catch (e) {
      return;
    }

    if (refUrl.origin !== window.location.origin) return;

    handle = collectionHandle(refUrl.pathname);
  }

  if (handle === null) return;

  var desired = handle.indexOf('wedding') !== -1 ? 'true' : '';

  var meta = document.querySelector('meta[name="wedding-context-source"]');
  var current = meta ? meta.getAttribute('data-current-value') || '' : '';
  if (current === desired) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  fetch(root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { wedding_context: desired } }),
  }).catch(function () {});
})();
